"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

let baseConfig;

function SLInternalGateway() {}

SLInternalGateway.init = function (config) {
  baseConfig = config;
};

SLInternalGateway.requestParams = function (params) {
  if (!baseConfig) {
    throw new Error('need init config first!');
  }

  if (typeof params.data !== 'object') {
    throw new TypeError('data must be an object!');
  }

  let headers = {
    'client-type': baseConfig.clientType || 'pc'
  };
  const reqParams = {
    url: baseConfig.baseUrl + params.path,
    body: {
      auth_type: 'cookie',
      data: params.data,
      app_id: baseConfig.appId,
      sub_appId: baseConfig.subAppId
    }
  };

  if (params.headers) {
    headers = _objectSpread(_objectSpread({}, headers), params.headers);
  } // @ts-ignore


  reqParams.headers = headers;
  return reqParams;
};

var _default = SLInternalGateway;
exports.default = _default;